const OptionTypes = {
    GET_OPTIONS: "GET_OPTIONS",
    GET_OPTIONS_SUCCESS: "GET_OPTIONS_SUCCESS",
    ADD_OPTIONS:"ADD_OPTIONS",
    ADD_OPTIONS_SUCCESS:"ADD_OPTIONS_SUCCESS"
};

export { OptionTypes };